import { ConfigurationTypes } from '../../vendor_core/core/src/const/ConfigurationTypes';
import ConfigManager from '../../vendor_core/core/src/managers/ConfigManager';
import { CurrencyType } from '../../vendor_core/core/src/managers/contracts/configurations/IBetConfig';
import ILocalConfig from '../../vendor_core/core/src/managers/contracts/configurations/ILocalConfig';
import BetModel from '../../vendor_core/core/src/model/BetModel';
import { version, name } from "../../package.json";
import CurrencyUtils from '../../vendor_core/core/src/utils/CurrencyUtils';
import JackpotsModel from '../../vendor_core/src/model/JackpotsModel';
import RealityCheckModel from '../../vendor_core/core/src/model/RealityCheckModel';
import App from '../../vendor_core/core/src/App';
import Configs from '../../vendor_core/src/vendorConfigs/Configs';
import BuyFeatureModel from '../../vendor_core/core/src/model/BuyFeatureModel';

class VendorLocalConfig implements ILocalConfig {
    type: ConfigurationTypes = ConfigurationTypes.LOCAL;
    overwritePatterns: { overwriteString: string; pattern: () => string; }[] = [
        {
            overwriteString: "{RTP}",
            pattern: () => Configs.game.getRTP().toFixed(2)
        },
        {
            overwriteString: "{WIN_CAP}",
            pattern: () => {return "10 000"}
        },
        {
            overwriteString: "{COST_FEATURE}",
            pattern: () => {
                if (ConfigManager.hasConfig(ConfigurationTypes.BUY_FEATURE)) {
                    return Configs.buyFeature.betMultiplier[2].toFixed();
                } else {
                    return "{13}";
                }
            }
        },
        {
            overwriteString: "{COST_BN1}",
            pattern: () => {
                if (ConfigManager.hasConfig(ConfigurationTypes.BUY_FEATURE)) {
                    return Configs.buyFeature.betMultiplier[0].toFixed();
                } else {
                    return "{100}";
                }
            }
        },
        {
            overwriteString: "{COST_BN2}",
            pattern: () => {
                if (ConfigManager.hasConfig(ConfigurationTypes.BUY_FEATURE)) {
                    return Configs.buyFeature.betMultiplier[1].toFixed();
                } else {
                    return "{200}";
                }
            }
        },
        {
            overwriteString: "{RTPBuyFeature}",
            pattern: () => {
                if (ConfigManager.hasConfig(ConfigurationTypes.BUY_FEATURE)) {
                    return Configs.buyFeature.buyFeatureRtp[2].toFixed(2);
                } else {
                    return "{RTPBuyFeature}";
                }
            }
        },
        {
            overwriteString: "{RTPBuyBN1}",
            pattern: () => {
                if (ConfigManager.hasConfig(ConfigurationTypes.BUY_FEATURE)) {
                    return Configs.buyFeature.buyFeatureRtp[0].toFixed(2);
                } else {
                    return "{RTPBuyBN1}";
                }
            }
        },
        {
            overwriteString: "{RTPBuyBN2}",
            pattern: () => {
                if (ConfigManager.hasConfig(ConfigurationTypes.BUY_FEATURE)) {
                    return Configs.buyFeature.buyFeatureRtp[1].toFixed(2);
                } else {
                    return "{RTPBuyBN2}";
                }
            }
        },
        {
            overwriteString: "{PriceBuy}",
            pattern: () => {
                if (ConfigManager.hasConfig(ConfigurationTypes.BUY_FEATURE)) {
                    return Configs.buyFeature.betMultiplier[BuyFeatureModel.mode].toString();
                } else {
                    return "{PriceBuy}";
                }
            }
        },
        {
            overwriteString: "{game_version}",
            pattern: () => version
        },
        {
            overwriteString: "{GAMENAME}",
            pattern: () => name
        },
        {
            overwriteString: "{game_datestamp}",
            pattern: () => App.config.versionDate
        },
        {
            overwriteString: "jackpot_fee",
            pattern: () => {
                if (Configs.bet.primaryCurrencyType == CurrencyType.Money) {
                    return CurrencyUtils.formatCurrency(JackpotsModel.jackpotFee, BetModel.currencyLocalization, true);
                } else {
                    return JackpotsModel.jackpotFee + " coins";
                }
            }
        },
        {
            overwriteString: "{playTime}",
            pattern: () => {
                const elapsedTime = RealityCheckModel.milliSecToMin(
                    RealityCheckModel.getElapsedTime()
                );
                //return elapsedTime.min.toString();
                return RealityCheckModel.totalSessionMinutes.toString();
            }

        },
        {
            overwriteString: "{betAmount}",
            pattern: () => {
                if (Configs.bet.primaryCurrencyType == CurrencyType.Money) {
                    return CurrencyUtils.formatCurrency(
                        (RealityCheckModel.totalBet / App.config.subUnits),
                        BetModel.currencyLocalization
                    ).toString()
                } else {
                    return JackpotsModel.jackpotFee + " coins";
                }
            }

        },
        {
            overwriteString: "{winAmount}",
            pattern: () => {
                if (Configs.bet.primaryCurrencyType == CurrencyType.Money) {
                    return CurrencyUtils.formatCurrency(
                        (RealityCheckModel.totalWin / App.config.subUnits),
                        BetModel.currencyLocalization
                    ).toString()
                } else {
                    return JackpotsModel.jackpotFee + " coins";
                }

            }

        },
        {
            overwriteString: "{result}",
            pattern: () => {
                if (Configs.bet.primaryCurrencyType == CurrencyType.Money) {
                    return CurrencyUtils.formatCurrency(
                        (RealityCheckModel.sessionMoneyResult / App.config.subUnits),
                        BetModel.currencyLocalization
                    ).toString()
                } else {
                    return JackpotsModel.jackpotFee + " coins";
                }

            }
        },
        {
            overwriteString: "progressive_jackpot_pool_reset_value",
            pattern: () => {
                const jackpotResetValue = 10000;
                if (Configs.bet.primaryCurrencyType == CurrencyType.Money) {
                    return CurrencyUtils.formatCurrency(jackpotResetValue, BetModel.currencyLocalization, true);
                } else {
                    return jackpotResetValue + " coins";
                }
            }
        }
    ];

}

export default new VendorLocalConfig()
